import i18next from '@packages/core/i18n';

import assessmentSummary from './en/assessment-summary.json';
import cyberResilienceAssessment from './en/cyber-resilience-assessment.json';
import files from './en/files.json';
import insurabilityRatingWidget from './en/insurability-rating-widget.json';
import insurabilityReport from './en/insurability-report.json';
import manageAssessmentWidget from './en/manage-assessment-widget.json';
import securityScoreWidget from './en/security-score-widget.json';
import summaryReport from './en/summary-report.json';
import topLevelGroupChartWidget from './en/top-level-group-chart-widget.json';

i18next.addResourceBundle(
  'en',
  'cyberResilienceAssessment',
  cyberResilienceAssessment,
);

i18next.addResourceBundle('en', 'securityScoreWidget', securityScoreWidget);
i18next.addResourceBundle('en', 'assessmentSummary', assessmentSummary);
i18next.addResourceBundle(
  'en',
  'manageAssessmentWidget',
  manageAssessmentWidget,
);
i18next.addResourceBundle(
  'en',
  'insurabilityRatingWidget',
  insurabilityRatingWidget,
);
i18next.addResourceBundle(
  'en',
  'topLevelGroupChartWidget',
  topLevelGroupChartWidget,
);
i18next.addResourceBundle('en', 'files', files);
i18next.addResourceBundle('en', 'summaryReport', summaryReport);
i18next.addResourceBundle('en', 'insurabilityReport', insurabilityReport);

export default i18next;
